/** Abort every pending AbortController in the ref's set and clear it. Swallows abort errors.
 *  No-op when the ref is missing or its `current` set isn't initialized, so it's safe to call
 *  from any cleanup path without a caller-side guard. */
export function abortAllPending(ref) {
  if (!ref || !ref.current) return;
  for (const ac of ref.current) {
    try {
      ac.abort();
    } catch {
      /* already settled */
    }
  }
  ref.current.clear();
}
